import { post,get } from "axios"
import store from '../../../store/index'

// 找件查询
const getFindList = async (data)=>{
    let code = ""
    if(store.state.shop==1780){
        code = store.state.is_sh=="0"?'丹阳仓':"上海仓"
    }
    let res = await post("index.php?act=web_index&op=sale_search",{
        ...data,
        code,
    })
    // brands:store.state.brands||""
    return res
}

const getFindBenzmList = async (data)=>{
    let code = ""
    if(store.state.shop==1780){
        code = store.state.is_sh=="0"?'丹阳仓':"上海仓"
    }
    let res = await post("index.php?act=web_index&op=sale_search_benzm",{
        ...data,
        code,
    })
    // brands:store.state.brands||""
    return res
}

// 商家分页找件查询
const getStoreSearch = async (data)=>{
    let res = await post("index.php?act=web_index&op=storeSearch",{
        ...data
    })
    return res
}
// 批量搜索
const getSearches = async (data)=>{
    let res = await post("index.php?act=web_index&op=searches",{
        ...data
    })
    return res
}
// 获取所有平台配件权限商家
const getDisAllStore = async (data)=>{
    let res = await post("index.php?act=web_index&op=getStore",{
        ...data
    })
    return res
}
// 今日到货查询
const getArrivedTodaySearch = async (data)=>{
    let code = ""
    if(store.state.shop==1780){
        code = store.state.is_sh=="0"?'丹阳仓':"上海仓"
    }
    if(store.state.store_id==1780){
        code = "丹阳仓"
    }
    let res = await post("index.php?act=goods_arrival&op=goods_arrival_search",{
        code,
        ...data
    })
    return res
}
// 添加到货提醒
const insert_goods_arrival = async (data)=>{
    let res = await post("index.php?act=goods_arrival&op=insert_goods_arrival",{
        ...data
    })
    return res
}
// 删除到货提醒
const delete_goods_arrival = async (data)=>{
    let res = await post("index.php?act=goods_arrival&op=del_goods_arrival",{
        ...data
    })
    return res
}
// 查询已到货提醒
const select_goods_arrival = async (data)=>{
    let res = await post("index.php?act=goods_arrival&op=select_goods_arrival",{
        ...data,
        code:"丹阳仓"
    })
    return res
}
// 查询催交
const select_goods_urge = async (data)=>{
    let res = await post("index.php?act=goods_arrival&op=select_goods_urge",{
        store_id:1780,
        ...data,
        code:"丹阳仓"
    })
    return res
}
// 添加催交
const insert_goods_urge = async (data)=>{
    let res = await post("index.php?act=goods_arrival&op=insert_goods_urge",{
        ...data
    })
    return res
}
const getWMparts = async (data)=>{
    const res =  await get("index.php?act=search&op=getWMparts",{
        params:{
            ...data
        }
    })
    return res
}
export {
    getStoreSearch,
    getFindList,
    getFindBenzmList,
    getArrivedTodaySearch,
    insert_goods_arrival,
    delete_goods_arrival,
    select_goods_arrival,
    select_goods_urge,
    insert_goods_urge,
    getSearches,
    getDisAllStore,
    getWMparts
}